export interface ISalaryRowType {
    id: string;
    code: string;
    name: string;
    measureUnit: string;
    decimals: number;
    hourBookingCategories: string[];
}

export enum SalaryRowTypeKindCode {
    Absence = "a",
    Hourbooking = "h",
    Vacation = "v",
}
